<template>
  <div id="instrument-outputs">
    <div>
      <div>
        <el-select
          v-model="outputType"
          size="large"
          @change="changeOutputType"
          placeholder="请选择状态">
          <el-option
            v-for="item in selectType"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div style="display:flex;margin-top: 10px;">
        <div style="margin-right: 5px">
          <el-input v-model="searchList.newMachineNO" size="large" placeholder="请输入新设备编号" clearable></el-input>
        </div>
        <div style="margin-right: 5px">
          <el-input v-model="searchList.name" size="large" placeholder="请输入仪器名称" clearable></el-input>
        </div>

        <div v-if="searchList && searchList['verificationValidDate'] !== undefined">
          <el-date-picker
            size="large"
            v-model="searchList.verificationValidDate"
            type="monthrange"
            unlink-panels
            format="yyyy-MM"
            start-placeholder="检定有效日期"
            end-placeholder="检定有效日期">
          </el-date-picker>
        </div>

        <div v-if="searchList && searchList['departmentId'] !== undefined">
          <el-select v-model="searchList.departmentId" placeholder="选择部门" size="small">
            <el-option
              v-for="item in departMentList"
              :key="item.departmentId"
              :label="item.name"
              :value="item.departmentId"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div style="display: flex;margin-top: 10px;flex-wrap: wrap">
        <div
          style="margin: 0 5px 5px 0"
          v-for="(value,item,index) in searchList"
          :key="index"
          v-if="item !== 'name' && item !== 'newMachineNO' && item !== 'verificationValidDate' && item !== 'departmentId'">
          <div v-if="item.includes('Date')">
            <el-date-picker
              v-model="searchList[item]"
              type="monthrange"
              size="large"
              unlink-panels
              :start-placeholder="keyToName[item]"
              :end-placeholder="keyToName[item]">
            </el-date-picker>
          </div>
          <el-select
            v-else-if="item === 'status'"
            v-model="searchList.status"
            size="large"
            placeholder="请选择状态">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input v-else v-model="searchList[item]" size="large" :placeholder="keyToName[item]" clearable></el-input>
        </div>
      </div>
    </div>
    
    <div style="display: flex;justify-content: space-around;margin-top:10px;">
      <div>
        <el-button size="large" style="background-color: #364876;color: #eee;width: 200px;" @click="ouPutAsExcel">下 载</el-button>
      </div>
      <div>
        <el-button size="large" style="background-color: #8499a8;color: #eee;width: 200px" @click="reset">重 置</el-button>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'instrument-outputs',
  data() {
    return {
      machineList: null,
      searchList: {
        'name': '','machineNO': '','newMachineNO': '','serialNO': '',
        'verificationConclusion': '','verificationAgency': '','verificationDate': '',
        'category': '','specs': '','purchaseDate': '','status': '','money': '',
        'manufacturer': '','verificationValidDate': '',
      },
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 10,
      loading: false,
      keyToName: this.$commondata.KEY_TO_NAME,
      statusOptions: [
        {name: '全部',value: '',},
        {name: '在用',value: '在用',},
        {name: '停用',value: '停用',},
        {name: '计量',value: '计量',},
        {name: '借出',value: '借出',},
        {name: '审核中',value: '审核中',},
        {name: '报废',value: '报废',},
        {name: '待检',value: '待检',},
      ],
      outputType: '',
      selectType: [
        {name: '溯源计划',value: 'traceability_plan',},
        {name: '溯源结果确认',value: 'traceability_confirm',},
        {name: '维修(维护)申请单',value: 'maintenance',},
        {name: '仪器设备履历',value: 'resume',},
      ],
      departMentList: [],
    }
  },
  async mounted(){
    if(this.searchList && this.searchList['departmentId'] !== undefined)
      this.departMentList = await this.$equipmentdata.getDepartMentList({});
  },
  methods: {
    ouPutAsExcel() {
      this.$confirm("是否下载当前搜索条件的设备数据",'提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let options = this.$util.formatOptions(this.searchList);
        let result = await this.$equipmentdata.downloadFile(this.outputType,options);
        let title = "";
        let contentype = {};
        if(this.outputType === 'traceability_plan'){
          title = "溯源计划表.docx";
        }else if(this.outputType === 'traceability_confirm'){
          title = "溯源结果确认表.docx";
        }else if(this.outputType === 'maintenance'){
          title = "维修(维护)申请单.docx";
        }else if(this.outputType === 'resume'){
          title = "仪器设备履历.docx";
        }
        contentype = {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8'}
        //console.log(result);
        this.$FileSaver.saveAs(
          new Blob([result], contentype),
          title
        );
      })
    },

    reset(){
      for(let item in this.searchList){
        this.searchList[item] = '';
      }
    },

    changeOutputType(e){
      if(e === 'traceability_plan'){
        this.searchList = {
          'name': '','machineNO': '','newMachineNO': '','serialNO': '',
          'verificationConclusion': '','verificationAgency': '','verificationDate': '',
          'category': '','specs': '','purchaseDate': '','status': '','money': '',
          'manufacturer': '','verificationValidDate': '',
        }
      }else if(e === 'traceability_confirm'){
        this.searchList = {
          'name': '','machineNO': '','newMachineNO': '','serialNO': '',
          'verificationConclusion': '','verificationAgency': '','verificationDate': '',
          'category': '','specs': '','purchaseDate': '','status': '','money': '',
          'manufacturer': '','verificationValidDate': '',
        }
      }else if(e === 'maintenance'){
        this.searchList = {
          'name': '','newMachineNO': '',
          'verificationConclusion': '','verificationAgency': '','verificationDate': '','purchaseDate': '','status': '','money': '',
          'manufacturer': '','verificationValidDate': '',
        }
      }else if(e === 'resume'){
        this.searchList = {
          'name': '','machineNO': '','newMachineNO': '','serialNO': '',
          'verificationConclusion': '','verificationAgency': '','verificationDate': '',
          'category': '','specs': '','purchaseDate': '','status': '','money': '',
          'manufacturer': '','verificationValidDate': '',
        }
      }
    },
  }
}
</script>
<style>
html,body{
  margin: 0;
  height: 100%;
}
#instrument-outputs{
  position: relative;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/instrument/Outputs.vue